import { styled } from '@linaria/react'

export const ImagesDesktopWrapper = styled.div`
  position: relative;
  display: block;

  &.reversed-column {
    ${ImagesDesktop} {
      left: 0;
      right: auto;
      align-items: flex-start;
      justify-content: flex-start;

      img {
        &:nth-child(2) {
          margin: -55px 0 0 -100px;
        }
      }
    }

    ${ImagesMobile} {
      @media screen and (max-width: 1023.98px) {
        img {
          margin: 0 0 0 auto;

          &:nth-child(2) {
            margin: 0;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }
`

export const ImagesDesktop = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  justify-content: flex-start;

  img {
    max-width: 100%;
    width: 100%;

    &:nth-child(2) {
      max-width: calc(50% + 100px);
      margin: -55px -100px 0 0;
    }
  }
`

export const Content = styled.div`
  display: block;

  &.reversed-column {
    ${ImagesMobile} {
      @media screen and (max-width: 1023.98px) {
        img {
          margin: 0 0 0 auto;

          &:nth-child(2) {
            margin: -45px 0 0;
          }
        }
      }
    }
  }
`

export const Description = styled.div`
  padding-left: ${props =>
    props.reversedColumns || (!props.reversedColumns && props.removeSpace)
      ? '0'
      : '150px'};
  padding-right: ${props =>
    !props.reversedColumns || (props.reversedColumns && props.removeSpace)
      ? '0'
      : '150px'};

  @media screen and (max-width: 767.98px) {
    padding: 0;
  }
`

export const Headline = styled.h6`
  text-transform: uppercase;
`

export const Title = styled.h1`
  position: relative;
  width: fit-content;
  margin-bottom: 20px;

  span {
    position: relative;
    z-index: 2;
  }

  .dhsv-svg {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 1;
  }

  .decor-circle {
    transform: translateY(25%);
  }

  @media screen and (max-width: 1023.98px) {
    .decor-wave {
      bottom: -8px;
    }
  }
`

export const Teaser = styled.p`
  margin-top: 40px;

  @media screen and (max-width: 767.98px) {
    margin-top: 20px;
  }
`

export const SecondHeadline = styled.h5`
  position: relative;
  width: fit-content;

  span {
    position: relative;
    z-index: 2;
  }

  .overlapping-images__decor-line {
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 1;
  }
`

export const ButtonWrapper = styled.div`
  margin-top: 36px;

  @media screen and (max-width: 1024px) {
    margin-top: 30px;
    text-align: center;
  }
`

export const ImagesMobile = styled.div`
  display: none;

  @media screen and (max-width: 1024px) {
    display: flex;
    flex-flow: column;
    align-items: flex-start;

    .overlapping-images__large-image {
      max-width: 80%;
    }

    .overlapping-images__small-image {
      max-width: 40%;
      margin: -45px 0 0 auto;
    }
  }

  @media screen and (max-width: 768px) {
    .overlapping-images__small-image {
      max-width: 55%;
    }
  }
`
